import React, { FC } from 'react';
import './ResultPane.scss';
import { IResultPaneProps } from './IResultPaneProps';
import Result from './Result/Result';


const ResultPane: FC<IResultPaneProps> = (props) => {
    let queryTextValue = props.queryText;

    return (
        /* 
           display: flex + flex-direction: column legger elementene under hverandre.
           gap: 1.5rem (24px) mellomrom mellom elementene.
        */
        <div className="ResultPane" style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
            {props.results.map((result, idx) => {
                return (
                    <Result 
                        key={`resultPaneParent-${idx}`} 
                        idx={idx} 
                        result={result} 
                        queryText={queryTextValue}
                    />
                );
            })}
        </div>
    );
};


export default ResultPane;
